import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { AppBar, Toolbar, Typography } from '@material-ui/core';
import zIndex from '@material-ui/core/styles/zIndex';
import { VERSION_WEB } from 'constants/version';

const useStyles = makeStyles(() => ({
  root: {
    boxShadow: 'none'
  }
}));

const Topbar = props => {
  const { className, ...rest } = props;

  const classes = useStyles();

  return (
    <AppBar
      {...rest}
      className={clsx(classes.root, className)}
      color="primary"
      position="fixed">
      <Toolbar>
        <RouterLink to="/">
          <Typography variant="h3" style={{ color: 'white' }}>
            INCENTIVE
          </Typography>
          <span style={{color:'#fff'}}>{VERSION_WEB}</span>
        </RouterLink>
      </Toolbar>
      <div
        style={{
          textAlign: 'right',
          marginTop: '-3em',
          paddingBottom: '1em',
          paddingRight: '1em',
          zIndex: 99
        }}>
        <a
          href="/admin"
          style={{
            color: '#fff'
          }}>
          Admin
        </a>
      </div>
    </AppBar>
  );
};

Topbar.propTypes = {
  className: PropTypes.string
};

export default Topbar;
